/* eslint-disable react/no-unknown-property */
import {
  FontWeight, Stack, Text, Popover, PopoverProps,
} from '@doveit/bricks';
import React from 'react';
import { pluralizeWord } from '@doveit/hammer';
import { Agency } from '../../../providers/api/dtos';
import * as styles from './AgencyPopover.style';

export interface AgencyPopoverProps extends React.AriaAttributes {
  agencies?: Agency[],
  trigger: PopoverProps['trigger'],
}

const AgencyPopover: React.FC<AgencyPopoverProps> = ({
  agencies,
  trigger,
  ...rest
}) => {
  const agenciesCount = agencies?.length || 0;
  const title = agenciesCount === 0
    ? "L'agente non appartiene a nessuna agenzia"
    : `${agenciesCount} ${pluralizeWord('agenzi', 'a', 'e', agenciesCount)}`;

  return (
    <Popover
      trigger={trigger}
      hasArrow
      {...rest}
    >
      <div css={styles.wrapper}>
        <Stack gap={150}>
          <Text.BodySmall
            as="strong"
            fontWeight={FontWeight.MEDIUM}
          >
            {title}
          </Text.BodySmall>

          <Stack gap={100}>
            {agencies?.map(({ id, shortName }) => (
              <Text.BodySmall
                key={id}
                fontWeight={FontWeight.REGULAR}
              >
                {shortName}
              </Text.BodySmall>
            ))}
          </Stack>
        </Stack>
      </div>
    </Popover>
  );
};

export default AgencyPopover;
